import { render } from "./UpdatePasswordForm.vue?vue&type=template&id=61889ef4"
import script from "./UpdatePasswordForm.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdatePasswordForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Profile/Partials/UpdatePasswordForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "61889ef4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61889ef4', __exports__)) {
    api.reload('61889ef4', __exports__)
  }
  
  module.hot.accept("./UpdatePasswordForm.vue?vue&type=template&id=61889ef4", () => {
    api.rerender('61889ef4', render)
  })

}


export default __exports__